module.exports = __webpack_public_path__ + "static/pleasanton-008-5ea0a92bea0a811afd1066e8743c67a4.jpg";